import { render, staticRenderFns } from "./GetLayerFromFile.vue?vue&type=template&id=3ff07fc9"
import script from "./GetLayerFromFile.vue?vue&type=script&lang=js"
export * from "./GetLayerFromFile.vue?vue&type=script&lang=js"
import style0 from "./GetLayerFromFile.vue?vue&type=style&index=0&id=3ff07fc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports